(function () {
  function initArrows(wrapper) {
    if (!wrapper) return;
    const gallery = wrapper.querySelector('media-gallery');
    if (!gallery) return;
    // Use the real main viewport, not the whole wrapper (fixes vertical centering)
    const slider = gallery.querySelector('[id^="Slider-Gallery-"]');
    const thumbs = gallery.querySelectorAll('[id^="Slider-Thumbnails-"] button');
    if (!slider || thumbs.length < 2) return; // no need if only one media
    if (slider.querySelector('.bb-gallery-arrows')) return;

    // Ensure the slider can host absolutely-positioned children
    slider.style.position = slider.style.position || 'relative';

    // Simple right-pointing chevron; we rotate for "prev" in CSS
    const chevron = `
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
      </svg>`;

    const overlay = document.createElement('div');
    overlay.className = 'bb-gallery-arrows';
    overlay.innerHTML = `
      <button type="button" class="bb-gallery-arrow bb-prev" aria-label="Previous image">
        ${chevron}
      </button>
      <button type="button" class="bb-gallery-arrow bb-next" aria-label="Next image">
        ${chevron}
      </button>
    `;
    slider.appendChild(overlay);

    function currentIndex() {
      return Array.from(thumbs).findIndex(b => b.hasAttribute('aria-current'));
    }
    function go(delta) {
      const i = currentIndex();
      if (i < 0) return;
      const next = Math.max(0, Math.min(thumbs.length - 1, i + delta));
      thumbs[next]?.click();
    }

    overlay.addEventListener('click', e => {
      if (e.target.closest('.bb-prev')) go(-1);
      if (e.target.closest('.bb-next')) go(1);
    });

    // Keyboard: left/right when a button is focused
    overlay.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  }

  function boot() {
    document.querySelectorAll('.product__media-wrapper').forEach(initArrows);
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
